import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import {
  listenForCookieChange,
  handle401Error,
  getCookie,
} from "./helpers/jwt";
import { ACCESS_TOKEN } from "./constants/constants";
import { isEmpty } from "lodash";
import { authService } from "./services/authService";
import { logoutCallback } from "./helpers/shared";
import Navbar from "./components/Navbar";
import AgentsList from "./pages/AgentsList";
import AgentChat from "./pages/AgentChat/AgentChat";
import "./App.css";

const App = () => {
  const [initialized, setInitialized] = useState(false);
  const [authError, setAuthError] = useState(false);

  async function getAccessToken() {
    console.log("Getting access token...");
    const existingToken = getCookie(ACCESS_TOKEN);
    if (!isEmpty(existingToken)) {
      setInitialized(true);
      return;
    }
    const res = await authService.handle401Error();
    if (res === "401") {
      setAuthError(true);
    }
    setInitialized(true);
  }

  useEffect(() => {
    getAccessToken();
    let hadToken = !isEmpty(getCookie(ACCESS_TOKEN));
    listenForCookieChange(ACCESS_TOKEN, async (newValue) => {
      const hasToken = !isEmpty(newValue);
      if (hadToken && !hasToken) {
        hadToken = false;
        const res = await authService.handle401Error();
        if (res === "401") {
          setAuthError(true);
        }
      } else if (hasToken) {
        hadToken = true;
      }
    });
  }, []);

  if (!initialized) return null;

  if (authError) {
    return (
      <div className="flex flex-col justify-center items-center h-screen space-y-4">
        <p className="text-lg text-gray-700">Please sign in to continue</p>
        <button
          className="cursor-pointer bg-[rgb(21,128,140)] text-white px-6 py-2 rounded hover:bg-[rgb(16,100,110)]"
          onClick={() => logoutCallback()}
        >
          Sign In
        </button>
      </div>
    );
  }

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/agents" element={<AgentsList />} />
        <Route path="/agent-chat" element={<AgentChat />} />
      </Routes>
    </Router>
  );
};

export default App;
